import React from "react";
import BaseInput from "../../../../components/BaseInput";
import { useTranslation } from "react-i18next";
import BaseFormBlock from "../BaseFormBlock";
import "./style.scss";
import PropTypes from "prop-types";
import AnswerTitle from "../AnswerTitle";
import BaseTextArea from "../../../../components/BaseTextArea";

export default function TextAnswer({ title, name, value, onChange, number }) {
  TextAnswer.propTypes = {
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };
  const { t } = useTranslation();

  return (
    <BaseFormBlock>
      <div className="insight-text-answer">
        <AnswerTitle title={title} number={number} />
        <div className="insight-text-answer__input-wrapper">
          <BaseTextArea
            className="insight-text-answer__input-wrapper--textarea"
            name={name}
            value={value}
            row={1}
            onChange={onChange}
            autoResize={true}
            placeholder={t("insight_questionnaire_form_page.myAnswer")}
          />
        </div>
      </div>
    </BaseFormBlock>
  );
}
